export interface InterventionErrors {
    well_id: boolean
    name: boolean
    start: boolean
}

export interface WellErrors {
    name: boolean
    wellType: boolean
    waterDepth: boolean
}

export interface Errors {
    intervention: InterventionErrors
    well: WellErrors
    messages: { intervention: string; well: string }
}

export const emptyInterventionErrors: InterventionErrors = {
    start: false,
    name: false,
    well_id: false
}
export const emptyWellErrors: WellErrors = {
    name: false,
    wellType: false,
    waterDepth: false
}
export function emptyErrors(): Errors {
    return {
        intervention: emptyInterventionErrors,
        well: emptyWellErrors,
        messages: { intervention: '', well: '' }
    }
}
